<template>
  <el-tag
    :class="label"
  >
    {{ label }}
  </el-tag>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_colors.scss";

  .el-tag {
    margin: 0px;
    margin-left: 2px;
    margin-right: 2px;
    font-size: 11px;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    line-height: 34px;
    font-weight: 700;
    border-radius: 24px;
    padding: 0 14px;
    border: none;

    &.admin {
      color: $light-orange;
      background-color: rgba(255, 151, 151, 0.12);
    }

    &.teacher {
      color: $blue;
      background-color: rgba(203, 151, 255, 0.12);
    }

    &.student {
      color: $purple;
      font-weight: 500;
      background-color: rgba(121, 215, 255, 0.16);
    }
  }

</style>
